import React from 'react'
import CloudStorage from '../../CloudStorage/CloudStorage'
import { Tooltip } from "react-tooltip";
import { chooseposttypetips } from './Tooltips/tooltip';

export default function ChoosePostType({ title }) {
    return (
        <div>
            <h6>
                {title} &nbsp;
                <img
                    data-tooltip-id="my-tooltip-2"
                    src={`${CloudStorage.cloudurl}/Assets/Images/postjob/post-icon.svg`}
                    alt=""
                />
            </h6>

            <Tooltip
                id="my-tooltip-2"
                place="bottom"
                content={chooseposttypetips}
            />
        </div>
    )
}
